import { ObjectViewerButton } from 'components/collection/object-viewer-button';
import { fetchObjects } from 'lib/collection/fetchObjects';
import * as Sentry from '@sentry/nextjs';
import { type PortableTextMarkComponentProps } from 'next-sanity';

// TODO: looks like this missed getting a storybook story. ideally coverage should include the not-found object state, as well.
export const CollectionPopUp = async (props: IProps) => {
	const { children, value } = props;

	const response = await fetchObjects({
		objectIDs: [value.objectWrapper.objectId],
	});
	const object = response.objects[0];

	if (!object) {
		Sentry.captureMessage(
			`CollectionPopUp couldn't find associated object. Value was: ${JSON.stringify(value)}`,
		);
		// it blows up if we try to render ObjectViewerButton, so just pass along plaintext or whatever.
		return <>{children}</>;
	}

	return <ObjectViewerButton text={children} object={object} />;
};

interface IProps extends PortableTextMarkComponentProps {
	children: string;
	value: {
		_type: string;
		objectWrapper: {
			objectId: number;
		};
	};
}

export default CollectionPopUp;
